import styled, { css } from 'styled-components'

export const Container = styled.div`
  width: 100%;
  *,
  [class~='masterApp-importCenterContainer'] {
    ._Pzs44 {
      padding: 0 !important;
      border: none;
    }
  }
  [class~='masterApp-FileBlock'] {
    border-radius: 8px;
  }
  [class~='translationsContainer'] {
    padding: 0;
  }
  .ant-select * {
    font-family: Roboto;
  }
  .ant-select-selection-selected-value {
    font-size: 14px !important;
  }
  input {
    border: 2px solid #d9d9d9;
    &::placeholder {
      color: #757575;
    }
  }
  textarea {
    border: 2px solid #d9d9d9;
    resize: none;
    &::placeholder {
      color: #757575;
    }
  }
  .ant-select {
    width: 100%;
  }
  .ant-select > div {
    border: 2px solid #d9d9d9 !important;
    li {
      border: none;
      border-radius: 8px;
      padding: 0;
    }
    li .ant-select-selection__choice__content {
      color: #262626;
      font-size: 12px;
      margin-top: 1px;
    }
    li > div > span > svg {
      margin-left: 8px;
    }
    li > span > i > svg {
      display: none;
    }
  }
  .ant-select > div:hover,
  .ant-select > div:focus,
  .ant-select-focused > div {
    border: 2px solid #40a9ff !important;
  }
  .ant-select-disabled > div:hover,
  .ant-select-disabled > div:focus {
    border: 2px solid #d9d9d9 !important;
  }
  .ant-select-dropdown {
    li {
      padding-top: 10px;
      padding-bottom: 10px;
      span > svg {
        display: none;
      }
    }
  }
  .ant-select-arrow > svg {
    color: #757575;
    font-size: 12px !important;
  }
  .ant-select-selection__placeholder,
  .ant-select-search__field {
    color: #757575;
    font-size: 14px !important;
  }
  .ant-select-selection--single {
    .ant-select-search__field {
      margin-left: -1px;
      width: 100% !important;
    }
  }
  .ant-select-selection--multiple {
    .ant-select-search__field {
      margin-left: 5px;
      padding-bottom: 5px !important;
      width: 100% !important;
    }
  }
  .ant-steps-item-title::after {
    background-color: #d9d9d9 !important;
  }
  tr:hover > td,
  .ant-table-row-hover > td,
  tbody > .ant-table-row-selected > td,
  tbody > .ant-table-row-selected:hover > td {
    background: #e6f7ff66 !important;
  }
  .ant-table-placeholder {
    border-bottom: none;
  }
  .ant-table-row-selected > td,
  .ant-table-row-selected:hover > td {
    background-color: #e7f3fe !important;
  }
  .rankmiTable-rowsCount {
    margin-bottom: 6px;
  }
  .rankmiTable-rowsCount > .ant-tag {
    background-color: #f5f5f5;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    font-size: 14px;
    color: #363636;
    svg {
      color: #363636;
      font-size: 12px;
      margin-right: 6px !important;
    }
  }
  .rankmiTable-rowsCount > .ant-tag + .ant-tag {
    background-color: #e7f3fe;
    border: 1px solid #b6dbfb;
    svg {
      color: #0085ff;
    }
    svg ~ svg {
      margin-left: 8px !important;
      margin-right: 2px !important;
      color: #363636;
    }
  }
  .rankmiTable-addButton {
    margin-right: 0 !important;
    border-radius: 8px;
    font-size: 14px;
    line-height: 16px;
    padding: 12px !important;
    height: 40px;
  }
  .rankmiTable-actions-container {
    height: 40px !important;
    width: 160px !important;
    margin-left: 8px !important;
  }
  .rankmiTable-searchInput {
    width: 280px !important;
    height: 40px;
  }
  .ant-table-column-title {
    color: #757575;
    font-size: 14px;
    font-family: Roboto;
  }
  .ant-table-fixed-right {
    box-shadow: -4px 0px 4px 0px #00000014;
  }
  ._3XOBP
    [class~='ant-table-fixed-right']
    [class~='ant-table-fixed']
    tbody
    > tr
    > td {
    border-left: none !important;
  }
  .ant-checkbox > span {
    border: 2px solid #bfbfbf;
    border-radius: 4px;
  }
  .ant-checkbox-checked > span {
    background-color: white;
    border: 2px solid #0085ff;
  }
  .ant-checkbox-checked > span::after {
    border-color: #0085ff;
    left: 2px;
  }
  .ant-checkbox-indeterminate > span::after {
    background-color: #0085ff;
    border-radius: 2px;
  }
  .ant-checkbox-checked::after {
    border-radius: 4px;
  }
  .rankmiTable-pagination {
    margin-top: 16px;
  }
  .rankmiTable-rowsPerPage > ._2-Xmr {
    margin-top: 23px;
    color: #757575 !important;
    font-family: Roboto !important;
  }
  .rankmiTable-showColumns-container {
    height: 40px !important;
  }
  .rankmiTable-filters-button {
    height: 40px;
  }
  ._2dbEN ._2PgTn ._1ZdAB {
    li {
      min-width: 32px;
      height: 32px !important;
      border-radius: 4px !important;
      margin-left: 4px !important;
      transition: 200ms;
      &:hover {
        opacity: 0.7;
      }
      a {
        padding: 3px 7px;
        color: #757575 !important;
      }
    }
    .ant-pagination-item {
      background-color: white !important;
      border: 2px solid #d9d9d9;
    }
    .ant-pagination-item-active {
      background-color: #e7f3fe !important;
      border-color: #0085ff !important;
    }
    .ant-pagination-jump-prev > a,
    .ant-pagination-jump-next > a {
      border-radius: 4px !important;
      background-color: white !important;
      border: 2px solid #d9d9d9;
      max-width: unset !important;
      max-height: unset !important;
      padding: 3px 4px 1px;
    }
    .ant-pagination-jump-prev:hover,
    .ant-pagination-jump-next:hover {
      a {
        padding: 4px 4px 0px;
        color: #0085ff !important;
      }
    }
    [class~='ant-pagination-item-active'] a {
      color: #0085ff !important;
    }
    [class~='ant-pagination-prev'],
    [class~='ant-pagination-next'] {
      background-color: #f0f0f0 !important;
      a {
        padding: 15px;
      }
      [class~='ant-pagination-item-link'] svg {
        color: #4c4c4c !important;
      }
    }
  }
  .ant-pagination-disabled {
    opacity: 0.48 !important;
  }
  .ant-switch-checked {
    background-color: #0085ff;
  }
  .ant-tabs-bar {
    border-bottom: 4px solid #d9d9d9;
    border-radius: 2px;
  }
  .ant-tabs-nav-container {
    margin-bottom: -4px;
  }
  .ant-tabs-ink-bar {
    height: 4px;
    background-color: #0085ff;
    border-radius: 2px;
  }
  .ant-tabs-tab {
    color: #757575;
    font-weight: bold;
    padding: 4px 0 16px;
    margin-right: 24px;
  }
  .ant-tabs-tab-active,
  .ant-tabs-tab:hover {
    color: #0085ff;
  }
  video {
    border-radius: 8px;
  }
`

interface IContentProps {
  shadow: boolean
}

export const Content = styled.div<IContentProps>`
  ${(props: IContentProps) =>
    props.shadow &&
    css`
      padding: 24px;
      border-radius: 16px;
      background: #ffffff;
      border: 1px solid #f0f0f0;
      box-shadow: 0px 4px 8px 0px #00000014;
    `}
`
